import { render, staticRenderFns } from "./VlFilterTemplate.vue?vue&type=template&id=babf8600&scoped=true&"
import script from "./VlFilterTemplate.vue?vue&type=script&lang=js&"
export * from "./VlFilterTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babf8600",
  null
  
)

export default component.exports